import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  header: {
    padding: "1rem",
  },
  body: {
    padding: "2rem",
  },
  overlay: {},
  dialog: {
    borderRadius: "0px",
    bg: "white",
  },
});

const ChakraUIModalStyling = defineMultiStyleConfig({
  baseStyle,
});

export default ChakraUIModalStyling;
